import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import validateRule from '../../../services/ruleValidator.service';
import { addMessage } from '../../../store/actions/message.actions';
import { createAndExecuteRules } from '../../../store/actions/rule.actions';

const styles = {
  textField: {
    paddingBottom: '15px',
  },
  btnPadding: {
    marginLeft: '5px',
    marginTop: '15px',
  },
  hide: {
    display: 'none',
  },
};

class RuleDefineRuleContainer extends Component {
  constructor(props) {
    super(props);

    this.validateRules = this.validateRules.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      input: '',
      isBusy: false,
    };
  }

  validateRules(rules) {
    const { isGlobal, columnKey, addMessage } = this.props;

    for(var x = 0; x < rules.length; x++) {
      if (rules[x].replace(/\s/g, '') === '') {
        addMessage('error', 'Rule #' + (x+1) + ' cannot be empty');
        return false;
      } else if (!isGlobal && columnKey.replace(/\s/g, '') === '') {
        addMessage('error', 'Header value empty, please contact developer');
        return false;
      } else if (!validateRule(rules[x])) {
        addMessage('error', 'Rule syntax not recognised for rule #' + (x+1) + ' "' + rules[x] + '"');
        return false;
      }
    }
    return true;
  }

  handleChange(event) {
    this.setState({ input: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { columnKey, createAndExecuteRules, addMessage } = this.props;
    const { input } = this.state;
    this.setState({isBusy: true});
    const rules = input.split('|');

    if(this.validateRules(rules)) {
      createAndExecuteRules(rules, columnKey);
      addMessage('success', 'Added rule(s)');
    }
    this.setState({
      input: '',
      isBusy: false,
    });
  }

  render() {
    const { classes} = this.props;

    return (
      <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
        <TextField
          name="rules"
          value={this.state.input}
          onChange={this.handleChange}
          label="New rule"
          className={classes.textField}
          disabled={this.state.isBusy}
        />
        <Button
            color="primary"
            variant="contained"
            className={classes.btnPadding}
            disabled={!this.state.input}
            onClick={this.handleSubmit}
          >
            {this.state.isBusy ? <CircularProgress size={24} /> : 'Add'}
          </Button>
      </form>
    );
  }
}

RuleDefineRuleContainer.propTypes = {
  columnKey: PropTypes.string,
  isGlobal: PropTypes.bool,
  column: PropTypes.shape({
    type: PropTypes.string,
  }),
  addMessage: PropTypes.func.isRequired,
  createAndExecuteRules: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

RuleDefineRuleContainer.defaultProps = {
  columnKey: '',
  isGlobal: false,
  column: null,
};

export default withStyles(styles)(connect(
  null,
  { addMessage, createAndExecuteRules },
)(RuleDefineRuleContainer));
